"use strict";

exports.__esModule = true;
exports.StyledTD = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledTD = _styledComponents.default.td`
    padding: 10px ${({
  theme
}) => theme.space[4]};
    
    ${_styledSystem.space}
    ${_styledSystem.layout}
    ${_styledSystem.typography}
    ${_styledSystem.color}
    ${_styledSystem.border}
    ${_styledSystem.position}
`;
exports.StyledTD = StyledTD;